import { generateSetChild, generateUpdateArrayChild } from '@/helpers/VuexHelpers'
import { service } from '@/service'
import { config } from '@/config'
import { fixProductTaxons } from '@/service/upgradeService'

export default {
	namespaced: true,
	state: {

	},
	actions: {
		async adjustChildProducts({ dispatch, state, getters, rootState }, { item, childCodes }) {
			if (item.children) {
				return await dispatch('cart/replaceCartItemChildren', { identifier: item.id, childCodes }, { root: true })
			} else {
				// console.warn("childprodcuts: this item has no children, should not happen", item)
			}
		},
	},
	getters: {
		childProducts(state, getters, rootState) {
			return rootState.cart.serverData
				? rootState.cart.serverData.availableChildProducts
					.map(item => {
						if (typeof item !== 'object') {
							item = rootState.cart.productMap[item]
						}
						let newItem = {
							code: item.code,
							name: item.variants[0].name,
							description: item.description,
							shortDescription: item.shortDescription,
							images: item.images,
							id: item.id,
							price: item.variants[0].price.current,
							taxons: item.taxons,
							availableInTaxons: item.availableInTaxons ? item.availableInTaxons.map(taxon => taxon.code) : [],
						}
						newItem = fixProductTaxons(newItem)
						return newItem
					})
				: []
		},
		childProductCategories(state, getters, rootState) {
			return rootState.cart.serverData
			? rootState.cart.serverData.childProductsCategories
			: []
		},
		childProductsByType(state, getters, rootState) {
			const categories = getters.childProductCategories;
			const products = getters.childProducts;

			const types = {
				option: [],
				extra: [],
			};

			categories.forEach(category => {
				if (!Array.isArray(types[category.type])) {
					types[category.type] = [];
				}
				types[category.type].push({
					...category,
					products: products.filter(v => v.taxons.includes(category.taxon))
				});
			});

			return types;
		}
	},
	mutations: {

	}
}
